import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import DonationPage from '../views/DonationPage.vue'
import DonationCallback from '../components/DonationCallback.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/donate/callback",
    name: "DonationsCallback",
    component: DonationCallback,
    beforeEnter: (to, from, next) => {
      const {status } = to.query
      if (status && status === 'success') window.localStorage.setItem('stripe_status', 'success')
      if (status && status === 'cancelled') window.localStorage.setItem('stripe_status', 'cancelled')
      next('/donate')
    }

  },
  {
    path: "/donate",
    name: "Donations",
    component: DonationPage,
  },
];

const router = new VueRouter({
    routes,
    mode: 'history'
});

export default router;
